<template>
  <b-card border-variant="light">
    <div class="widget-label" v-if="title">
      <div class="label">
        <p>{{ title }}</p>
      </div>
    </div>
    <div class="p-0 widget-content">
      <b-row v-if="owners.length || (contractors.length && split) || guests.length" class="mt-2">
        <b-col>
          <p class="label align-left">Owners:</p>
          <AttendeesEntries
            v-if="owners.length"
            :attendees="owners"
            :action="action"
            @handleRemove="$parent.handleAttendeeRemove"
            @handleAdd="$parent.handleAttendeeAdd"
          />
          <p v-else>No Owners</p>
        </b-col>
        <b-col>
          <p class="label align-left">Contractors:</p>
          <AttendeesEntries
            v-if="contractors.length"
            :attendees="contractors"
            :action="action"
            @handleRemove="$parent.handleAttendeeRemove"
            @handleAdd="$parent.handleAttendeeAdd"
          />
          <p v-else>No Contractors</p>
        </b-col>
        <b-col v-if="guests.length">
          <p class="label align-left">Guests:</p>
          <AttendeesEntries
            :attendees="guests"
            :action="action"
            @handleRemove="$parent.handleAttendeeRemove"
            @handleAdd="$parent.handleAttendeeAdd"
          />
        </b-col>
      </b-row>
      <AttendeesEntries
        v-else
        :attendees="displayableAttendees"
        :action="action"
        :column="column"
        @handleRemove="$parent.handleAttendeeRemove"
        @handleAdd="$parent.handleAttendeeAdd"
      />
    </div>

    <b-card-footer
      v-if="allowShowAll && !showAll && attendees.length > 5"
      class="no-border__footer"
      style="background: white"
    >
      <b-button class="text-button" @click="showModal('more-attendees-modal')">
        Show all {{ attendees.length }} Attendees
      </b-button>
      <b-modal
        ref="more-attendees-modal"
        :title="title"
        ok-only
        ok-title="Close"
      >
        <AttendeesEntries
          :attendees="attendees"
          :action="action"
          @handleRemove="$parent.handleAttendeeRemove"
          @handleAdd="$parent.handleAttendeeAdd"
        />
      </b-modal>
    </b-card-footer>
    <b-card-text v-if="attendees.length === 0" style="margin: 20px">
      <p>{{ emptyText }}</p>
    </b-card-text>
  </b-card>
</template>

<script>
import AttendeesEntries from "../list-entries/AttendeesEntries.vue";
export default {
  components: { AttendeesEntries },
  data() {
    return {
    };
  },
  props: {
    title: { type: String },
    attendees: { type: Array, required: true },
    meetingInviteUrl: { type: String, default: "" },
    emptyText: { type: String, default: "No Attendees" },
    action: { type: String, default: "" },
    allowInvites: { type: Boolean, default: false },
    showAll: { type: Boolean, default: false },
    allowShowAll: { type: Boolean, default: true },
    column: { type: Boolean, default: false },
    split: { type: Boolean, default: false },
  },
  methods: {
    toggleAttending(userId) {
      let attendee = this.attendees.find((a) => a.userId === userId);
      if (attendee.attending) {
        this.$parent.handleAttendeeRemove(attendee);
      } else {
        this.$parent.handleAttendeeAdd(attendee);
      }
    },
    showModal(name) {
      this.$refs[name].show();
    },
    borderClassByRole(attendee) {
      if (attendee.role == "Owner") {
        return "owner";
      } else if (attendee.role == "Contractor") {
        return "contractor";
      } else {
        return "";
      }
    },
  },
  computed: {
    displayableAttendees() {
      return this.showAll ? this.attendees : this.attendees.slice(0, 5);
    },
    owners() {
      return this.displayableAttendees.filter((a) => a.role == "Owner");
    },
    contractors() {
      return this.displayableAttendees.filter((a) => a.role == "Contractor");
    },
    guests() {
      return this.displayableAttendees.filter((a) => a.role == "Guest");
    },
  },
};
</script>

<style lang="scss" scoped>
</style>